import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Query from 'dashboard-services/api/Query';

import { builderPipelineCreatorActions } from 'actions/modules/datascience';
import getApiConfig from 'api/ApiConfig';
import { pipelinesQueries } from 'queries/modules/datascience';

import HierarchySorter from './HierarchySorter';

import { Point } from '@projectstorm/geometry';

export default (() => {

  const EMPTY_ARRAY = []
  const EMPTY_OBJ = {}
  const useHierarchySort = ({ diagram }) => {
    const dispatch = useDispatch(),
          builderTasks = useSelector(state => state.datascienceState.creatorState.builderState.tasks) || EMPTY_OBJ,
          builderLinks = useSelector(state => state.datascienceState.creatorState.builderState.links) || EMPTY_ARRAY,
          MessageStore = useSelector(state => state.globalState.MessageStore),
          getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
          getQueryBuilder = useCallback(() => 
            new Query.Builder(getApiConfigLocal())
              .withFetching(false)
          , [getApiConfigLocal]),
          { data: categoriesRaw } = pipelinesQueries.useGetCategories({ getQueryBuilder }),
          categories = categoriesRaw || EMPTY_ARRAY,
          hierarchySort = useCallback(() => dispatch(HierarchySorter.sort({ builderLinks, builderTasks, categories, diagram, MessageStore })), [builderLinks, builderTasks, categories, diagram, dispatch, MessageStore])
    return hierarchySort;
  }

  const useAutoAlign = ({ diagram }) => {
    const dispatch = useDispatch(),
          autoAlign = useCallback(() => {
            const positions = {};
            const updates = [];

            diagram.getActiveModel().getNodes().forEach(node => {
              const position = new Point(HierarchySorter.roundTo(node.position.x, 80), HierarchySorter.roundTo(node.position.y, 80));
              positions[node.options.id] = { x: position.x, y: position.y };
              updates.push([node, position]);
            });

            dispatch(builderPipelineCreatorActions.changePositions(positions));

            requestAnimationFrame(() => {
              updates.forEach(([node, position]) => {
                node.__silent = true;
                node.setPosition(position)
                node.__silent = false;
              })
              diagram.getDiagramEngine().repaintCanvas();
            });
          }, [diagram, dispatch])
    return autoAlign;
  }

  const useIsBlockedByWarehouseAccess = () => {
    const hasWarehouseAccess = useSelector(state => state.datascienceState.creatorState.builderState.hasWarehouseAccess,),
          shouldHaveWarehouseAccess = useSelector(state => state.datascienceState.creatorState.builderState.shouldHaveWarehouseAccess)
    return hasWarehouseAccess === false && shouldHaveWarehouseAccess === true;
  };

  return {
    useHierarchySort,
    useAutoAlign,
    useIsBlockedByWarehouseAccess
  }
})()